<app-header></app-header>

<div class="frow-container main">
  <div class="content-container">
    <router-outlet></router-outlet>
  </div>

</div>
<app-footer></app-footer>

<div class="transaction-loading frow centered" [class.is-visible]="(transactionLoading$ | async)">
  <div class="modal-body">
    <div class="spinner">
      <div class="double-bounce1"></div>
      <div class="double-bounce2"></div>
    </div>
    <p class="mt-20 text-center">{{ (loadingText$ | async) || 'Loading...' }}</p>
  </div>
</div>

<div class="congratulations-container frow centered" *ngIf="(showCongratulation$ | async) as amount">
  <div class="modal-body">
    <h3 class="mt-20">Congratulations!</h3>
    <p>You have adopted {{ amount }} {{ amount >1 ? 'Tezzardz' : 'Tezzard'}}.</p>
    <p>Thank you for supporting these snazzy wee fukkrs. They really appreciate it, rawrrzzz!</p>
    <p>You can view your Tezzardz on <a href="https://objkt.com/">objkt.com</a></p>
    <p><button (click)="dismiss()" class="button">Close</button></p>
  </div>
</div>